module.exports = __webpack_public_path__ + "static/media/kouiUwagi.ab6a1a7a.png";